import { useParams } from 'react-router-dom'

import CustomTimeRanges from 'modules/attendance/components/CustomTimeRanges'
import { CustomTimeRangeProvider } from 'modules/attendance/hooks/useCustomTimeRange'

const CustomTimeRangesPage = () => {
  const { settingId } = useParams()

  return (
    <CustomTimeRangeProvider>
      <CustomTimeRanges settingId={Number(settingId)} />
    </CustomTimeRangeProvider>
  )
}

export default CustomTimeRangesPage
